import { createApp, h } from "vue";
import Animation from "./Animation.vue";
import Vue3Lottie from "vue3-lottie";

console.log("[ValueTeaserIconAnimations] Script loaded");

const BASE_URL =
  "https://dqe0grvfek50d.cloudfront.net/content/dam/mycoke/us/en/animations";

console.log("[ValueTeaserIconAnimations] BASE_URL:", BASE_URL);

const classToAnimationMap = {
  "effortless-ordering": `${BASE_URL}/value-prop-ordering.json`,
  "seamless-service": `${BASE_URL}/value-prop-service.json`,
  "digital-platform": `${BASE_URL}/value-prop-digital.json`,
  "business-partner": `${BASE_URL}/value-prop-partners.json`,
  "iconic-brands": `${BASE_URL}/value-prop-brands.json`,
};

console.log(
  "[ValueTeaserIconAnimations] classToAnimationMap:",
  classToAnimationMap
);

// Cache for loaded animations
const animationCache = new Map();

console.log("[ValueTeaserIconAnimations] animationCache initialized");

// Function to load animation JSON from URL
const loadAnimation = async (url) => {
  console.log(
    "[ValueTeaserIconAnimations] loadAnimation called with URL:",
    url
  );

  if (animationCache.has(url)) {
    console.log(
      "[ValueTeaserIconAnimations] Animation found in cache for URL:",
      url
    );
    return animationCache.get(url);
  }

  try {
    console.log(
      "[ValueTeaserIconAnimations] Fetching animation data from:",
      url
    );
    const response = await fetch(url);
    console.log(
      "[ValueTeaserIconAnimations] Fetch response status:",
      response.status
    );
    if (!response.ok) {
      throw new Error(`Failed to load animation: ${response.status}`);
    }
    const animationData = await response.json();
    console.log(
      "[ValueTeaserIconAnimations] Animation data loaded successfully for URL:",
      url,
      animationData
    );
    animationCache.set(url, animationData);
    return animationData;
  } catch (error) {
    console.error(
      `[ValueTeaserIconAnimations] Error loading animation from ${url}:`,
      error
    );
    return null;
  }
};

const initAnimations = async () => {
  console.log("[ValueTeaserIconAnimations] initAnimations called");
  const cmpTeasers = document.querySelectorAll(".animated-value-icon");
  console.log(
    "[ValueTeaserIconAnimations] Found .animated-value-icon elements:",
    cmpTeasers.length,
    cmpTeasers
  );

  for (const teaser of cmpTeasers) {
    console.log(
      "[ValueTeaserIconAnimations] Processing teaser element:",
      teaser
    );
    const animationContainer = teaser.querySelector(".cmp-teaser__content");
    console.log(
      "[ValueTeaserIconAnimations] animationContainer:",
      animationContainer
    );

    if (animationContainer) {
      const classes = Array.from(teaser.classList);
      console.log("[ValueTeaserIconAnimations] teaser.classList:", classes);

      const animationClass = classes.find((classs) =>
        classToAnimationMap.hasOwnProperty(classs)
      );
      console.log(
        "[ValueTeaserIconAnimations] animationClass found:",
        animationClass
      );

      const animationUrl = classToAnimationMap[animationClass];
      console.log("[ValueTeaserIconAnimations] animationUrl:", animationUrl);

      if (animationUrl) {
        console.log(
          "[ValueTeaserIconAnimations] Attempting to load animation for class:",
          animationClass
        );
        const animation = await loadAnimation(animationUrl);
        console.log("[ValueTeaserIconAnimations] Animation loaded:", animation);

        if (animation) {
          console.log(
            "[ValueTeaserIconAnimations] Creating animation mount point"
          );
          const animationMountPoint = document.createElement("div");
          animationMountPoint.classList.add("cmp-teaser__image");
          animationContainer.insertBefore(
            animationMountPoint,
            animationContainer.firstChild
          );
          console.log(
            "[ValueTeaserIconAnimations] animationMountPoint inserted:",
            animationMountPoint
          );

          console.log(
            "[ValueTeaserIconAnimations] Creating Vue app for animation"
          );
          const app = createApp({
            render: () => {
              console.log(
                "[ValueTeaserIconAnimations] Rendering Animation component",
                { animation, height: 72, width: "auto" }
              );
              return h(Animation, { animation, height: 72, width: "auto" });
            },
          });

          app.use(Vue3Lottie);
          console.log("[ValueTeaserIconAnimations] Mounting Vue app");
          app.mount(animationMountPoint);
          console.log(
            "[ValueTeaserIconAnimations] Vue app mounted on",
            animationMountPoint
          );
        } else {
          console.warn(
            "[ValueTeaserIconAnimations] Animation failed to load for URL:",
            animationUrl
          );
        }
      } else {
        console.warn(
          "[ValueTeaserIconAnimations] No animation URL found for teaser classes:",
          classes
        );
      }
    } else {
      console.warn(
        "[ValueTeaserIconAnimations] No .cmp-teaser__content container found in teaser element:",
        teaser
      );
    }
  }
  console.log("[ValueTeaserIconAnimations] Animation initialization complete");
};

// Expose to window for external triggering
window.initValueTeaserIconAnimations = initAnimations;
